(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CategoryService', CategoryService)

    /** @ngInject */
    function CategoryService(HttpService) {
        const CategoryService = {
            get,
            getAll,
            getByParameters,
            post,
            put,
            migrateData,
            deleteData
        }

        return CategoryService;

        function get(categoryId) {
            return HttpService.get(`/categories/${categoryId}`);
        }

        function getAll() {
            return HttpService.get('/categories/by-parameters');
        }

        function getByParameters(params) {
            return HttpService.get('/categories/by-parameters', {
                params
            });
        }

        function post(categoryData) {
            return HttpService.post('/categories', categoryData);
        }

        function put(categoryData) {
            return HttpService.put('/categories', categoryData);
        }

        function migrateData(categoryOriginId, categoryDestinationId) {
            return HttpService.put(`/categories/migrate/${categoryOriginId}/${categoryDestinationId}`);
        }

        function deleteData(categoryId) {
            return HttpService.delete(`/categories/${categoryId}`);
        }
    }
}());